import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, Select} from "antd"
import {exportBatchItemsOverTime} from "../../../services/api/3dApi"

const {Option} = Select

class ExportModal extends Component {
    state = {
        value: 'printed',
    }

    _handleChange = (value) => {
        this.setState({
            value: value
        })
    }

    _exportData = () => {
        const {value} = this.state
        const {onCloseModal} = this.props

        if (typeof onCloseModal === 'function') {
            onCloseModal()
        }

        try {
            window.open(exportBatchItemsOverTime(`overtime=${value}`))
        } catch (e) {
            console.log(e.message)
        }
    }

    render() {
        const {openModal, onCloseModal} = this.props
        const {value} = this.state

        return (
            <div className="ExportModal">
                <Modal
                    visible={openModal}
                    title="Kết xuất dữ liệu"
                    onCancel={onCloseModal}
                    footer={null}
                >
                    <div className='p-3 d-flex align-items-center justify-content-between'>
                        <Select
                            defaultValue='over_printed'
                            value={value}
                            className='mr-3'
                            onChange={this._handleChange}
                        >
                            <Option value='printed'>Danh sách items quá hạn in</Option>
                            <Option value='transferred'>Danh sách items quá hạn ép</Option>
                            <Option value='qc'>Danh sách items quá hạn QC</Option>
                        </Select>

                        <Button icon='cloud-download' type='primary' onClick={this._exportData}>
                            Export
                        </Button>
                    </div>
                </Modal>
            </div>
        )
    }
}

ExportModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired
}

export default ExportModal
